<template>
  <div>
    <main>
      <div class="container">
        <RouterView />
      </div>
    </main>
  </div>
</template>

<script>
import { getSessionTracker } from "./event-log/sessionTracker";

export default {
  mounted() {
    this.trackDisplayedPage();
  },
  watch: {
    "$route.fullPath"() {
      getSessionTracker()?.pause();
      this.trackDisplayedPage();
    },
  },
  beforeDestroy() {
    getSessionTracker()?.pause();
  },
  methods: {
    trackDisplayedPage() {
      const route = this.$route;
      this.$nextTick(() => {
        if (this.$route === route && route.matched.length && route.name !== "NotFound") {
          getSessionTracker()?.display(route.path);
        }
      });
    },
  },
};
</script>
